import { Router, UrlTree } from '@angular/router';

import { wsLink } from '../shared/utils/workspace-link';
import { SETUP_STEP_QUERY_PARAM, WORKSPACE_ONLY_STEP } from './setup.constants';
import { SemerisRoutes } from '../shared/constants/routes';

/**
 * Where to send a user whose selected workspace can't be resolved: the wizard's workspace step,
 * whatever the reason and whatever the list holds. It is the only screen that frames the pick as
 * required and says why the list is short — the browse page reads as optional browsing.
 */
export function workspaceRepickUrl(router: Router): UrlTree {
  return router.createUrlTree(wsLink(SemerisRoutes.setup), {
    queryParams: { [SETUP_STEP_QUERY_PARAM]: WORKSPACE_ONLY_STEP },
  });
}
